import { QNA_STATUS } from '../qnaConstants';

/**
 * Normalize Firestore Timestamp / Date / number to epoch millis.
 */
export function toMillis(value) {
  if (value == null) return null;
  if (typeof value === 'number') return value;
  if (value instanceof Date) return value.getTime();
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}

/**
 * Shared unread rule: activityAt > readAt.
 *
 * @param {object} params
 * @param {*} params.activityAt - Content or room activity timestamp
 * @param {*} params.readAt - User lastRead entry for the item/room
 * @param {*} [params.neverOpenedDefault] - Used when readAt is missing (chat: room.lastMessageAt)
 */
export function isItemUnread({ activityAt, readAt, neverOpenedDefault = null }) {
  const activityMs = toMillis(activityAt);
  if (activityMs == null || activityMs <= 0) return false;

  const readMs = readAt != null
    ? toMillis(readAt)
    : toMillis(neverOpenedDefault);

  if (readMs == null) return true;
  return activityMs > readMs;
}

export function getQuestionActivityAt(question) {
  if (question?.status === QNA_STATUS.CLOSED) {
    return question?.answeredAt ?? question?.lastActivityAt ?? question?.createdAt ?? null;
  }
  return question?.lastActivityAt ?? question?.createdAt ?? null;
}

/**
 * Chat room list unread — dot semantics (not message counts).
 * Never-opened rooms assume caught up via neverOpenedDefault = lastMessageAt.
 */
export function isChatRoomUnread(room, lastReadMap) {
  const unitId = room?.messageUnit || room?.id;
  if (!unitId) return false;

  return isItemUnread({
    activityAt: room?.lastMessageAt ?? null,
    readAt: lastReadMap?.[unitId],
    neverOpenedDefault: room?.lastMessageAt ?? null,
  });
}
